import { TrendingDown } from 'lucide-react'
import { Link } from 'react-router-dom'

import { useAnalyticsSignals } from '@/hooks/features/analytics'

import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

/**
 * Home: a one-line pointer to Analytics when the nightly check found changes for the worse that nobody has dismissed.
 * Shows nothing otherwise, also for staff without analytics access.
 */
export const AnalyticsSignalsNote = () => {
  const { data } = useAnalyticsSignals()
  const open = (data?.result ?? []).filter((s) => !s.good && s.status === 'open')
  if (!open.length) return null
  const urgent = open.filter((s) => s.severity === 'high').length
  return (
    <Card className="flex items-center gap-3 p-3">
      <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-warning-lighter text-warning-dark" aria-hidden="true">
        <TrendingDown className="size-4" />
      </span>
      <p className="min-w-0 flex-1 text-sm text-ink">
        {open.length === 1 ? '1 change' : `${open.length} changes`} in your store's last week worth a look
        {urgent > 0 && <span className="text-muted-foreground"> · {urgent} need attention</span>}
      </p>
      <Button variant="link" size="sm" asChild>
        <Link to="/analytics">View in Analytics</Link>
      </Button>
    </Card>
  )
}
